// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"131ea2ba","120":"44522ba4","439":"0e5a3558","553":"e9aeb922","607":"522d7c9a","611":"93bc2795","631":"59c9f5cb","636":"841a6780","734":"40181bf5","777":"412b3fd0","801":"e495512d","898":"dc6222fc","977":"e6f6a900"}[chunkId] + ".chunk.js";
};